<template>
  <div class="order">
    <search-order
      v-on:resetSearch="resetSearch"
      v-on:onSubmit="onSubmit"
      :payStateList="payStateList"
      :payTypeList="payTypeList"
      :search="search"
      :dateTime="dateTime"
    >
    </search-order>
    <abnormal-order-dialog
      :visible.sync="abnormalDialogVisible"
      :order-info="abnormalOrder"
      :approval-status-options="approvalStatusOptions"
      @close="handleAbnormalDialogClosed"
      @refresh="handleAbnormalRefresh"
    />
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="orderList"
        style="width: 100%"
        max-height="638"
        :border="true"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="userName"
          :label="$t('order.userName')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="190"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('order.equipmentNo')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="210"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentName"
          :label="$t('order.equipmentName')"
          width="150"
          :align="'center'"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
        ></el-table-column>
        <el-table-column
          prop="orderNumber"
          :label="$t('order.orderNumber')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="280"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="openDoorTime"
          :label="$t('order.openDoorTime')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="190"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="doorVerifyStatus"
          :label="$t('order.doorVerifyStatus')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="190"
          :align="'center'"
        >
          <template slot-scope="scope">
            {{ formatDoorVerifyStatus(scope.row.doorVerifyStatus) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="recogId"
          :label="$t('order.recogId')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="190"
          :align="'center'"
        >
          <template slot-scope="scope">
            {{ scope.row.ordersOpenDoorDTO && scope.row.ordersOpenDoorDTO.recogId || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPerm(['manual:review:label'])"
          prop="visualManualIntervention"
          :label="$t('order.visualManualIntervention')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="110"
          :align="'center'"
        >
          <template slot-scope="scope">
            {{ formatVisualManualIntervention(scope.row.ordersOpenDoorDTO && scope.row.ordersOpenDoorDTO.visualManualIntervention) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="payState"
          :label="$t('order.payState')"
          class-name="order-table__nowrap"
          width="110"
          :align="'center'"
        >
          <template slot-scope="scope">
            {{ payState(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="payablePrice"
          :label="$t('order.actualPrice')"
          class-name="order-table__nowrap"
          width="100"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('order.createTime')"
          :show-overflow-tooltip="true"
          class-name="order-table__nowrap"
          width="190"
          :align="'center'"
          sortable="custom"
        ></el-table-column>
        <el-table-column fixed="right" :label="$t('header.operation')" min-width="220" :align="'center'">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.userVerifyStatus === 2 && scope.row.payState !== 3"
              type="warning"
              plain
              size="mini"
              @click="openAbnormalDialog(scope.row)"
            >
              {{ $t("order.handleAbnormal") }}
            </el-button>
            <el-button size="mini" @click="openDetail(scope.row)">
              {{ $t("operation.info") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('components.OrderDetailDialog.971063-0')"
      :visible.sync="detailDialogVisible"
      width="1100px"
      top="7vh"
    >
      <div class="detail-dialog-body">
        <section class="detail-summary">
          <div class="detail-summary__main">
            <div class="detail-summary__eyebrow">
              <i class="el-icon-data-analysis"></i>
              <span>{{ $t("order.detailOverview") }}</span>
            </div>
            <h2 class="detail-summary__title">{{ detailOrder.orderNumber || "-" }}</h2>
            <div class="detail-summary__meta">
              <div v-for="item in detailSummaryMetaList" :key="item.label" class="detail-summary__meta-item">
                <span class="detail-summary__meta-label">{{ item.label }}</span>
                <span class="detail-summary__meta-value">{{ item.value }}</span>
              </div>
            </div>
          </div>
          <div class="detail-summary__aside">
            <div class="detail-summary__tags">
              <el-tag effect="dark" :type="payStateTagType(detailOrder.payState)">
                <span class="detail-summary__tag-content">
                  <i :class="payStateTagIcon(detailOrder.payState)"></i>
                  <span>{{ payState(detailOrder) || "-" }}</span>
                </span>
              </el-tag>
              <el-tag effect="plain" :type="doorVerifyStatusTagType(detailOrder.doorVerifyStatus)">
                <span class="detail-summary__tag-content">
                  <i :class="doorVerifyStatusTagIcon(detailOrder.doorVerifyStatus)"></i>
                  <span>{{ formatDoorVerifyStatus(detailOrder.doorVerifyStatus) }}</span>
                </span>
              </el-tag>
              <el-tag
                v-if="checkPerm(['manual:review:label']) && Number(detailOpenDoorInfo.visualManualIntervention) === 1"
                effect="plain"
                type="success"
              >
                <span class="detail-summary__tag-content">
                  <i class="el-icon-s-check"></i>
                  <span>{{ $t("order.visualManualIntervention") }}</span>
                </span>
              </el-tag>
            </div>
            <div class="detail-summary__stats">
              <div v-for="metric in detailKeyMetrics" :key="metric.label" class="summary-stat">
                <span class="summary-stat__label">{{ metric.label }}</span>
                <strong class="summary-stat__value">{{ metric.value }}</strong>
              </div>
            </div>
          </div>
        </section>

        <div class="detail-layout">
          <div class="detail-main">
            <section v-for="group in orderInfoGroups" :key="group.title" class="detail-section">
              <div class="detail-section__header">
                <div class="detail-section__title">
                  <i :class="group.icon"></i>
                  <span>{{ group.title }}</span>
                </div>
              </div>
              <div class="detail-kv-grid">
                <div
                  v-for="field in group.fields"
                  :key="field.key"
                  class="detail-kv"
                  :class="{ 'detail-kv--wide': isWideDetailField(field.key) }"
                >
                  <div class="detail-kv__label">{{ field.label }}</div>
                  <div class="detail-kv__value">{{ renderDetailValue(detailOrder[field.key], field.formatter, field.key) }}</div>
                </div>
              </div>
            </section>

            <section v-for="group in openDoorInfoGroups" :key="group.title" class="detail-section">
              <div class="detail-section__header">
                <div class="detail-section__title">
                  <i :class="group.icon"></i>
                  <span>{{ group.title }}</span>
                </div>
              </div>
              <div class="detail-kv-grid">
                <div
                  v-for="field in group.fields"
                  :key="field.key"
                  class="detail-kv"
                  :class="{ 'detail-kv--wide': isWideDetailField(field.key) }"
                >
                  <div class="detail-kv__label">{{ field.label }}</div>
                  <div class="detail-kv__value">
                    <template v-if="field.key === 'orderQrCode'">
                      <el-image
                        v-if="detailOpenDoorInfo.orderQrCode"
                        class="detail-qr-code"
                        :src="detailOpenDoorInfo.orderQrCode"
                        fit="contain"
                        :preview-src-list="[detailOpenDoorInfo.orderQrCode]"
                      >
                        <div slot="error">{{ '-' }}</div>
                      </el-image>
                      <span v-else>-</span>
                    </template>
                    <template v-else>
                      {{ renderDetailValue(detailOpenDoorInfo[field.key], field.formatter, field.key) }}
                    </template>
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-section">
              <div class="detail-section__header">
                <div class="detail-section__title">
                  <i class="el-icon-video-camera"></i>
                  <span>开门视频</span>
                </div>
                <el-tag size="mini" type="info">{{ detailVideoResources.length }}</el-tag>
              </div>
              <div v-loading="detailVideoLoading">
                <div v-if="detailVideoResources.length" class="detail-media-grid">
                  <div
                    v-for="(item, index) in detailVideoResources"
                    :key="item.id || item.resourceUrl || index"
                    class="detail-video-card"
                  >
                    <video
                      class="detail-video-player"
                      :src="item.resourceUrl"
                      controls
                      preload="metadata"
                    ></video>
                  </div>
                </div>
                <el-empty v-else :description="$t('common.noData')"></el-empty>
              </div>
            </section>

            <section class="detail-section">
              <div class="detail-section__header">
                <div class="detail-section__title">
                  <i class="el-icon-goods"></i>
                  <span>{{ $t("order.ordersGoods") }}</span>
                </div>
                <el-tag size="mini" type="info">{{ (detailOrder.ordersGoods || []).length }}</el-tag>
              </div>
              <div v-if="(detailOrder.ordersGoods || []).length" class="goods-list">
                <article
                  v-for="(item, index) in detailOrder.ordersGoods"
                  :key="item.id || index"
                  class="goods-item"
                >
                  <div class="goods-item__image">
                    <el-image
                      v-if="getOrderGoodsImage(item)"
                      :src="getOrderGoodsImage(item)"
                      fit="contain"
                    >
                      <div slot="error" class="goods-card__image-placeholder">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <div v-else class="goods-card__image-placeholder">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </div>
                  <div class="goods-item__body">
                    <div class="goods-item__header">
                      <div class="goods-item__title">{{ item.goodsName || "-" }}</div>
                      <div class="goods-item__qty">{{ $t("order.buyNum") }} {{ item.buyNum || 0 }}</div>
                    </div>
                    <div class="goods-item__metrics">
                      <div class="goods-item__metric">
                        <span>{{ $t('order.successNum') }}</span>
                        <strong>{{ item.successNum || 0 }}</strong>
                      </div>
                      <div class="goods-item__metric">
                        <span>{{ $t('order.discountPrice') }}</span>
                        <strong>{{ item.discountPrice || "-" }}</strong>
                      </div>
                      <div class="goods-item__metric">
                        <span>{{ $t('order.actualPrice') }}</span>
                        <strong>{{ item.payablePrice || "-" }}</strong>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
              <el-empty v-else :description="$t('common.noData')"></el-empty>
            </section>
          </div>

          <aside class="detail-side">
            <section class="detail-section detail-section--side">
              <div class="detail-section__header">
                <div class="detail-section__title">
                  <i class="el-icon-time"></i>
                  <span>{{ $t("order.timeline") }}</span>
                </div>
              </div>
              <div class="detail-list">
                <div v-for="item in detailTimeline" :key="item.label" class="detail-list__item">
                  <span class="detail-list__label">{{ item.label }}</span>
                  <strong class="detail-list__value">{{ item.value }}</strong>
                </div>
              </div>
            </section>

            <section class="detail-section detail-section--side">
              <div class="detail-section__header">
                <div class="detail-section__title">
                  <i class="el-icon-postcard"></i>
                  <span>{{ $t("order.identityInfo") }}</span>
                </div>
              </div>
              <div class="detail-list">
                <div v-for="item in detailIdentityList" :key="item.label" class="detail-list__item">
                  <span class="detail-list__label">{{ item.label }}</span>
                  <strong class="detail-list__value">{{ item.value }}</strong>
                </div>
              </div>
            </section>
          </aside>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">{{ $t("common.cancel") }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import AbnormalOrderDialog from "_c/order/AbnormalOrderDialog.vue";
  import searchOrder from "_c/order/SearchOrder";
  import jsonView from "@/components/json-view/index.vue";
  import { checkPerm } from "@/utils/permission";
  export default {
    name: "Order",
    components: {
      AbnormalOrderDialog,
      searchOrder,
      jsonView
    },
    data() {
      return {
        search: {
          equipmentNo: "",
          equipmentName: "",
          orderNumber: "",
          payState: "",
          startTime: "",
          endTime: "",
          userName: "",
          recogId: "",
          visualManualIntervention: ""
        },
        dateTime: [],
        loading: false,
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        detailDialogVisible: false,
        detailVideoLoading: false,
        abnormalDialogVisible: false,
        detailOrder: {},
        abnormalOrder: {},
        approvalStatusOptions: [],
        payStateList: [],
        orderList: [],
        payTypeList: [],
        dialogQueryJoinRefundOrder: false,
        orderNumber: ""
      };
    },
    computed: {
      zone() {
        return this.$store.getters.zone;
      },
      detailOpenDoorInfo() {
        return this.detailOrder.ordersOpenDoorDTO || {};
      },
      detailVideoResources() {
        const orderLevelResources = this.detailOrder.openDoorResourceDTOs;
        if (Array.isArray(orderLevelResources)) {
          return orderLevelResources;
        }
        const openDoorLevelResources = this.detailOpenDoorInfo.videoResource;
        if (Array.isArray(openDoorLevelResources)) {
          return openDoorLevelResources;
        }
        return [];
      },
      orderInfoGroups() {
        return [
          {
            title: this.$t('order.userMachineInfo'),
            icon: 'el-icon-user',
            description: this.$t('order.userMachineInfoDesc'),
            fields: [
              { key: 'userName', label: this.$t('order.userName') },
              { key: 'nickName', label: this.$t('order.nickName') },
              { key: 'equipmentName', label: this.$t('order.equipmentName') },
              { key: 'equipmentNo', label: this.$t('order.equipmentNo') },
              { key: 'equipmentId', label: this.$t('order.equipmentId') },
              { key: 'uid', label: this.$t('order.uid') }
            ]
          },
          {
            title: this.$t('order.paymentInfo'),
            icon: 'el-icon-wallet',
            description: this.$t('order.paymentInfoDesc'),
            fields: [
              { key: 'payType', label: this.$t('order.payType'), formatter: this.formatPayType },
              { key: 'payState', label: this.$t('order.payState'), formatter: value => this.payState({ payState: value }) },
              { key: 'payablePrice', label: this.$t('order.actualPrice') },
              { key: 'payPrice', label: this.$t('order.payPrice') },
              { key: 'discountPrice', label: this.$t('order.discountPrice') },
              { key: 'vatPrice', label: this.$t('order.vatPrice') },
              { key: 'vatRate', label: this.$t('order.vatRate') }
            ]
          },
          {
            title: this.$t('order.orderMeta'),
            icon: 'el-icon-tickets',
            description: this.$t('order.orderMetaDesc'),
            fields: [
              { key: 'id', label: this.$t('order.id') },
              { key: 'orderNumber', label: this.$t('order.orderNumber') },
              { key: 'buyNum', label: this.$t('order.buyNum') },
              { key: 'buyTime', label: this.$t('order.buyTime') },
              { key: 'payTime', label: this.$t('order.payTime') },
              { key: 'createTime', label: this.$t('order.createTime') },
              { key: 'updateTime', label: this.$t('order.updateTime') },
              { key: 'refundPrice', label: this.$t('order.refundPrice') },
              { key: 'refundTime', label: this.$t('order.refundTime') },
              { key: 'refundMsg', label: this.$t('order.refundInfo') },
              { key: 'notes', label: this.$t('order.notes') }
            ]
          }
        ];
      },
      openDoorInfoGroups() {
        return [
          {
            title: this.$t('order.doorSession'),
            icon: 'el-icon-unlock',
            description: this.$t('order.doorSessionDesc'),
            fields: [
              { key: 'openDoorTime', label: this.$t('order.openDoorTime') },
              { key: 'closeDoorTime', label: this.$t('order.closeDoorTime') },
              { key: 'detectType', label: this.$t('order.detectType'), formatter: this.formatDetectType },
              { key: 'doorVerifyStatus', label: this.$t('order.doorVerifyStatus'), formatter: this.formatDoorVerifyStatus },
              { key: 'sysVerifyWeight', label: this.$t('order.sysVerifyWeight'), formatter: this.formatSysVerifyWeight },
              { key: 'userVerifyStatus', label: this.$t('order.userVerifyStatus'), formatter: this.formatUserVerifyStatus },
              { key: 'openDoorStatus', label: this.$t('order.openDoorStatus'), formatter: this.formatOpenDoorStatus },
              { key: 'openResultDescription', label: this.$t('order.openResultDescription') }
            ]
          },
          {
            title: this.$t('order.gatewaySettlement'),
            icon: 'el-icon-bank-card',
            description: this.$t('order.gatewaySettlementDesc'),
            fields: [
              { key: 'authAmount', label: this.$t('order.authAmount') },
              { key: 'payFinishTime', label: this.$t('order.payFinishTime') },
              { key: 'transactionId', label: this.$t('order.transactionId') },
              { key: 'sessionId', label: this.$t('order.sessionId') },
              { key: 'delayTime', label: this.$t('order.delayTime') },
              { key: 'timeoutWarnTime', label: this.$t('order.timeoutWarnTime') },
              { key: 'cardPayInfo', label: this.$t('order.cardPayInfo') },
              { key: 'mqSend', label: this.$t('order.mqSend'), formatter: this.formatMqSend }
            ]
          },
          {
            title: this.$t('order.doorMeta'),
            icon: 'el-icon-document',
            description: this.$t('order.doorMetaDesc'),
            fields: [
              { key: 'id', label: this.$t('order.id') },
              { key: 'ordersId', label: this.$t('order.ordersId') },
              { key: 'orderNumber', label: this.$t('order.orderNumber') },
              { key: 'recogId', label: this.$t('order.recogId') },
              { key: 'orderQrCode', label: this.$t('order.orderQrCode') },
              { key: 'createTime', label: this.$t('order.createTime') },
              { key: 'updateTime', label: this.$t('order.updateTime') },
              { key: 'notes', label: this.$t('order.notes') }
            ]
          }
        ];
      },
      detailKeyMetrics() {
        return [
          {
            label: this.$t('order.actualPrice'),
            value: this.detailOrder.payablePrice || '-'
          },
          {
            label: this.$t('order.authAmount'),
            value: this.detailOrder.authAmount || '-'
          },
          {
            label: this.$t('order.detectType'),
            value: this.formatDetectType(this.detailOrder.detectType)
          },
          {
            label: this.$t('order.buyNum'),
            value: this.detailOrder.buyNum === 0 ? '0' : this.detailOrder.buyNum || '-'
          }
        ];
      },
      detailTimeline() {
        return [
          { label: this.$t('order.createTime'), value: this.detailOrder.createTime || '-' },
          { label: this.$t('order.openDoorTime'), value: this.detailOrder.openDoorTime || '-' },
          { label: this.$t('order.closeDoorTime'), value: this.detailOrder.closeDoorTime || '-' },
          { label: this.$t('order.payFinishTime'), value: this.detailOrder.payFinishTime || '-' }
        ];
      },
      detailIdentityList() {
        return [
          { label: this.$t('order.orderId'), value: this.detailOrder.id || '-' },
          { label: this.$t('order.uid'), value: this.detailOrder.uid || '-' },
          { label: this.$t('order.doorId'), value: this.detailOpenDoorInfo.id || '-' },
          { label: this.$t('order.transactionId'), value: this.detailOpenDoorInfo.transactionId || '-' },
          { label: this.$t('order.sessionId'), value: this.detailOpenDoorInfo.sessionId || '-' },
          { label: this.$t('order.recogId'), value: this.detailOpenDoorInfo.recogId || '-' }
        ];
      },
      detailSummaryMetaList() {
        return [
          { label: this.$t('order.userName'), value: this.detailOrder.userName || '-' },
          {
            label: this.$t('order.equipmentName'),
            value: this.detailOrder.equipmentName || this.detailOrder.equipmentNo || '-'
          },
          { label: this.$t('order.createTime'), value: this.detailOrder.createTime || '-' },
          { label: this.$t('order.payType'), value: this.formatPayType(this.detailOrder.payType) }
        ];
      }
    },
    mounted() {
      let _self = this;
      _self.listPayState();
      _self.listPayType();
      _self.listApprovalStatus();
      _self.currentChange();
    },
    methods: {
      sortChange(column) {
        if (column.order === "ascending") {
          this.search.order = "asc";
          this.search.sort = column.prop;
        } else if (column.order === "descending") {
          this.search.order = "desc";
          this.search.sort = column.prop;
        } else {
          delete this.search.sort;
          delete this.search.order;
        }
        this.page.pageIndex = 1;
        this.currentChange();
      },
      revoke(row) {
        this.$confirm(this.$t("order.tipcontent"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Order.refundByOrderId, this.$method.post, {
              orderId: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange(1);
              }
            });
        });
      },
      listPayState() {
        this.$api.dict("gp_pay_state").then(res => {
          if (res.code === 0) {
            this.payStateList = res.data;
          }
        });
      },
      listPayType() {
        this.$api.dict("gp_pay_type").then(res => {
          if (res.code === 0) {
            this.payTypeList = res.data;
          }
        });
      },
      listApprovalStatus() {
        this.$api.dict("approval_status_list").then(res => {
          if (res.code === 0) {
            this.approvalStatusOptions = Array.isArray(res.data)
              ? res.data.map(item => ({
                  value: Number(item.value ?? item.dictValue),
                  label: item.label || item.dictLabel
                }))
              : [];
          }
        });
      },

      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.Order.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.orderList = (res.data.records || []).map(item => this.normalizeOrder(item));
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      normalizeOrder(order) {
        const openDoorInfo = order.ordersOpenDoorDTO || {};
        const fallbackFields = [
          'openDoorTime',
          'closeDoorTime',
          'detectType',
          'doorVerifyStatus',
          'sysVerifyWeight',
          'userVerifyStatus',
          'authAmount',
          'payFinishTime'
        ];

        return fallbackFields.reduce((result, field) => {
          if (result[field] === null || result[field] === undefined || result[field] === '') {
            result[field] = openDoorInfo[field];
          }
          return result;
        }, { ...order });
      },
      loadOrderVideoResources(targetKey, loadingKey, ordersId) {
        if (!ordersId) {
          this[targetKey] = {
            ...this[targetKey],
            openDoorResourceDTOs: []
          };
          return;
        }

        this[loadingKey] = true;
        this.$api
          .request(this.$url.OpenDoor.getOrderVideoResources, this.$method.get, {
            ordersId
          })
          .then(res => {
            if (res.code === 0) {
              const openDoorResourceDTOs = Array.isArray(res.data) ? res.data : [];
              this[targetKey] = {
                ...this[targetKey],
                openDoorResourceDTOs
              };
            }
            this[loadingKey] = false;
          })
          .catch(() => {
            this[loadingKey] = false;
          });
      },
      loadDetailVideoResources(ordersId) {
        this.loadOrderVideoResources("detailOrder", "detailVideoLoading", ordersId);
      },
      openDetail(row) {
        this.detailOrder = {
          ...row,
          openDoorResourceDTOs: []
        };
        this.detailDialogVisible = true;
        this.loadDetailVideoResources(row.id);
      },
      openAbnormalDialog(row) {
        this.abnormalOrder = { ...row };
        this.abnormalDialogVisible = true;
      },
      handleAbnormalDialogClosed() {
        this.abnormalOrder = {};
      },
      handleAbnormalRefresh() {
        this.abnormalDialogVisible = false;
        this.currentChange(this.page.pageIndex);
      },
      getOrderGoodsImage(item) {
        return item.goodsUrl || this.detailOrder.goodsUrl || '';
      },
      isWideDetailField(key) {
        return ['refundMsg', 'notes', 'cardPayInfo', 'orderQrCode'].includes(key);
      },
      renderDetailValue(value, formatter, key) {
        if (key === 'openDoorStatus') {
          return this.formatOpenDoorStatus(value);
        }
        if (key === 'mqSend') {
          return this.formatMqSend(value);
        }
        if (key === 'detectType') {
          return this.formatDetectType(value);
        }
        if (key === 'doorVerifyStatus') {
          return this.formatDoorVerifyStatus(value);
        }
        if (key === 'sysVerifyWeight') {
          return this.formatSysVerifyWeight(value);
        }
        if (key === 'userVerifyStatus') {
          return this.formatUserVerifyStatus(value);
        }
        if (formatter) {
          return formatter(value);
        }
        if (value === null || value === undefined || value === '') {
          return '-';
        }
        if (typeof value === 'object') {
          return JSON.stringify(value);
        }
        return value;
      },
      // 格式化订单状态内容
      payState(row) {
        return this.$cloud.getDictLabel(this.payStateList, row.payState);
      },
      formatPayType(value) {
        return this.$cloud.getDictLabel(this.payTypeList, value) || '-';
      },
      payStateTagType(status) {
        if ([1].includes(status)) {
          return 'success';
        }
        if ([0, 2].includes(status)) {
          return 'warning';
        }
        return 'info';
      },
      payStateTagIcon(status) {
        const tagType = this.payStateTagType(status);
        if (tagType === 'success') {
          return 'el-icon-success';
        }
        if (tagType === 'warning') {
          return 'el-icon-time';
        }
        return 'el-icon-info';
      },
      // 格式化识别类型
      formatDetectType(type) {
        const typeMap = {
          1: this.$t('order.visualWeight'),
          2: this.$t('order.visual'),
          3: this.$t('order.weight')
        };
        return typeMap[type] || '-';
      },
      // 格式化开门柜识别结果
      formatDoorVerifyStatus(status) {
        const statusMap = {
          1: this.$t('order.doorVerifyStatus1'),
          2: this.$t('order.doorVerifyStatus2'),
          3: this.$t('order.doorVerifyStatus3'),
          4: this.$t('order.doorVerifyStatus4'),
          6: this.$t('order.doorVerifyStatus6'),
          7: this.$t('order.doorVerifyStatus7'),
          8: this.$t('order.doorVerifyStatus8'),
          9: this.$t('order.doorVerifyStatus9'),
          10: this.$t('order.doorVerifyStatus10')
        };
        return statusMap[status] || '-';
      },
      formatOpenDoorStatus(status) {
        const statusMap = {
          1: this.$t('order.openDoorStatus1'),
          2: this.$t('order.openDoorStatus2'),
          3: this.$t('order.openDoorStatus3')
        };
        return statusMap[status] || '-';
      },
      doorVerifyStatusTagType(status) {
        if ([2, 3].includes(status)) {
          return 'success';
        }
        if ([1].includes(status)) {
          return 'warning';
        }
        if ([4, 6, 7, 8, 9, 10].includes(status)) {
          return 'danger';
        }
        return 'info';
      },
      doorVerifyStatusTagIcon(status) {
        const tagType = this.doorVerifyStatusTagType(status);
        if (tagType === 'success') {
          return 'el-icon-success';
        }
        if (tagType === 'warning') {
          return 'el-icon-time';
        }
        if (tagType === 'danger') {
          return 'el-icon-warning';
        }
        return 'el-icon-info';
      },
      // 格式化重量校验结果
      formatSysVerifyWeight(status) {
        const statusMap = {
          0: this.$t('order.sysVerifyWeight0'),
          1: this.$t('order.sysVerifyWeight1'),
          2: this.$t('order.sysVerifyWeight2')
        };
        return statusMap[status] || '-';
      },
      // 格式化告警处理结果
      formatUserVerifyStatus(status) {
        const statusMap = {
          1: this.$t('order.userVerifyStatus1'),
          2: this.$t('order.userVerifyStatus2')
        };
        return statusMap[status] || '-';
      },
      formatMqSend(status) {
        const statusMap = {
          0: this.$t('order.mqSend0'),
          1: this.$t('order.mqSend1')
        };
        return statusMap[status] || '-';
      },
      // 格式化视觉人工介入标识
      formatVisualManualIntervention(value) {
        return Number(value) === 1
          ? this.$t('order.visualManualInterventionYes')
          : this.$t('order.visualManualInterventionNo');
      },
      checkPerm,

      onSubmit(data) {
        this.search = data;
        this.dateTime = [new Date(data.startTime), new Date(data.endTime)];
        this.currentChange();
      },
      resetSearch(data) {
        this.search = data;
        // this.getDefault();
        this.currentChange();
      }
    }
  };
</script>

<style scoped lang="scss">
  ::v-deep .order-table__nowrap .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .detail-dialog-body {
    max-height: 72vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 20px;
  }

  .detail-summary {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) minmax(320px, 0.9fr);
    gap: 20px;
    padding: 20px 24px;
    margin-bottom: 16px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #ffffff;
  }

  .detail-summary__eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 500;
    color: #909399;
  }

  .detail-summary__eyebrow i {
    color: #8b93a6;
  }

  .detail-summary__title {
    margin: 0;
    font-size: 24px;
    line-height: 1.3;
    font-weight: 600;
    color: #303133;
    word-break: break-word;
  }

  .detail-summary__meta {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;
    margin-top: 16px;
  }

  .detail-summary__meta-item {
    min-width: 0;
  }

  .detail-summary__meta-label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: #909399;
  }

  .detail-summary__meta-value {
    display: block;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
    color: #303133;
    word-break: break-word;
  }

  .detail-summary__aside {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
  }

  .detail-summary__tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
  }

  .detail-summary__tag-content {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    line-height: 1;
  }

  .detail-summary__tag-content i {
    font-size: 13px;
  }

  .detail-summary__stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .summary-stat {
    padding: 12px 14px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fafafa;
  }

  .summary-stat__label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: #909399;
  }

  .summary-stat__value {
    display: block;
    font-size: 16px;
    line-height: 1.4;
    font-weight: 600;
    color: #303133;
  }

  .detail-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.55fr) minmax(280px, 0.75fr);
    gap: 16px;
    align-items: start;
  }

  .detail-main,
  .detail-side {
    min-width: 0;
  }

  .detail-side {
    position: sticky;
    top: 0;
  }

  .detail-side__status {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  }

  .detail-section {
    margin-bottom: 16px;
    padding: 18px 20px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #fff;
  }

  .detail-section--side {
    padding: 16px 18px;
  }

  .detail-section__header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f2f6fc;
  }

  .detail-section__title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .detail-section__title i {
    font-size: 15px;
    color: #8b93a6;
  }

  .detail-kv-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;
  }

  .detail-kv {
    min-width: 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5f7fa;
  }

  .detail-kv--wide {
    grid-column: 1 / -1;
  }

  .detail-kv__label {
    margin-bottom: 4px;
    font-size: 12px;
    color: #909399;
  }

  .detail-kv__value {
    font-size: 14px;
    line-height: 1.6;
    font-weight: 500;
    color: #303133;
    word-break: break-word;
  }

  .detail-list {
    display: grid;
    gap: 10px;
  }

  .detail-list__item {
    padding-bottom: 10px;
    border-bottom: 1px solid #f5f7fa;
  }

  .detail-list__label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: #909399;
  }

  .detail-list__value {
    display: block;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
    color: #303133;
    word-break: break-word;
  }

  .detail-media-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .detail-video-card {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
    background: #000;
  }

  .detail-video-player {
    display: block;
    width: 100%;
    max-height: 240px;
    background: #000;
  }

  .detail-qr-code {
    display: inline-block;
    width: 120px;
    height: 120px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fff;
  }

  .goods-list {
    display: grid;
    gap: 12px;
  }

  .goods-item {
    display: grid;
    grid-template-columns: 88px minmax(0, 1fr);
    gap: 14px;
    align-items: start;
    padding: 14px 16px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    background: #ffffff;
    transition: border-color 0.18s ease, background-color 0.18s ease;
  }

  .goods-item:hover {
    border-color: #d9ecff;
    background: #fcfdff;
  }

  .goods-item__image {
    width: 88px;
    height: 88px;
    flex-shrink: 0;
    overflow: hidden;
    border-radius: 6px;
    background: #f5f7fa;
  }

  .goods-item__image ::v-deep .el-image {
    display: block;
    width: 100%;
    height: 100%;
  }

  .goods-item__image ::v-deep .el-image__inner {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #fff;
  }

  .goods-card__image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #c0c4cc;
    font-size: 24px;
  }

  .goods-item__body {
    min-width: 0;
  }

  .goods-item__header {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 12px;
    align-items: flex-start;
  }

  .goods-item__title {
    min-width: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    color: #303133;
    word-break: break-word;
  }

  .goods-item__qty {
    flex-shrink: 0;
    padding: 4px 10px;
    border-radius: 12px;
    background: #f4f4f5;
    font-size: 12px;
    font-weight: 500;
    color: #606266;
  }

  .goods-item__metrics {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
  }

  .goods-item__metric {
    padding-top: 8px;
    border-top: 1px solid #f2f6fc;
  }

  .goods-item__metric span {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: #909399;
  }

  .goods-item__metric strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }

  ::v-deep .detail-summary__tags .el-tag,
  ::v-deep .detail-side__status .el-tag {
    border-radius: 4px;
  }

  ::v-deep .json-view-container {
    overflow-x: auto;
  }

  @media (max-width: 1199px) {
    .detail-summary,
    .detail-layout {
      grid-template-columns: 1fr;
    }

    .detail-side {
      position: static;
    }
  }

  @media (max-width: 767px) {
    .detail-dialog-body {
      padding: 16px;
    }

    .detail-summary,
    .detail-section {
      padding: 16px;
      border-radius: 8px;
    }

    .detail-summary__title {
      font-size: 20px;
    }

    .detail-summary__meta,
    .detail-summary__stats,
    .detail-kv-grid,
    .detail-media-grid,
    .goods-item__metrics {
      grid-template-columns: 1fr;
    }

    .goods-item {
      grid-template-columns: 1fr;
    }

    .goods-item__image {
      width: 100%;
      max-width: 112px;
      height: 112px;
    }

    .goods-item__header {
      flex-direction: column;
    }
  }
</style>
